import React from 'react';
import BusinessList from '../components/admin/BusinessList';
import { Box } from '@mui/material';


const BusinessesPage = () => {
  return (
    <Box
     sx={{ height: '100%', background: 'transparent', p: 2 }}
    >
      <BusinessList />
    </Box>
  );
};

export default BusinessesPage;
